import { css, type FC } from "dreamland/core";

export function CircularProgress(
	this: FC<{
		progress: number;
		size?: string;
		strokeWidth?: string;
		color?: string;
	}>
) {
	const radius = 100;
	const circumference = 2 * Math.PI * radius;

	use(this.progress).listen((p) => {
		if (p == 0) {
			this.root.classList.remove("visible");
		} else {
			this.root.classList.add("visible");

			this.root
				.querySelector("circle.moving")!
				.setAttribute("stroke-dashoffset", circumference * (1 - p) + "px");
		}
	});

	return (
		<svg
			width="200"
			height="200"
			viewBox="0 0 200 200"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			style="transform:rotate(-90deg)"
		>
			<circle
				r="90"
				cx="100"
				cy="100"
				class="inactive"
				stroke-width="16px"
				stroke-linecap="round"
				stroke-dashoffset="0px"
				fill="transparent"
				stroke-dasharray="565.48px"
			></circle>
			<circle
				r="90"
				cx="100"
				cy="100"
				class="moving"
				stroke-width="16px"
				stroke-linecap="round"
				stroke-dashoffset="118.692px"
				fill="transparent"
				stroke-dasharray="565.48px"
			></circle>
		</svg>
	);
}
CircularProgress.style = css`
	:scope {
		pointer-events: none;
		position: absolute;
		top: 2px;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		transition: opacity 0.2s ease;
		transform: rotate(-90deg);
	}
	:scope.visible {
		opacity: 1;
	}
	circle {
		fill: transparent;
		stroke: var(--tab_line);
		/*transition: stroke-dashoffset 0.2s ease;*/
	}
	circle.inactive {
		stroke: var(--text-15);
	}
`;
